export default __webpack_public_path__ + "images/c1e9b28ad90df472aab6e261f17e9859.svg";